import { useEffect } from 'react';

/**
 * Simple hotkey hook for Meta/Ctrl + key combos.
 *
 * Usage: useHotkey('k', () => openPalette(), { meta: true })
 */
export function useHotkey(
  key: string,
  handler: (e: KeyboardEvent) => void,
  opts: { meta?: boolean; shift?: boolean; alt?: boolean; enabled?: boolean } = {},
) {
  const { meta = false, shift = false, alt = false, enabled = true } = opts;
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() !== key.toLowerCase()) return;
      if (meta && !(e.metaKey || e.ctrlKey)) return;
      if (!meta && (e.metaKey || e.ctrlKey)) return;
      if (shift !== e.shiftKey) return;
      if (alt !== e.altKey) return;
      handler(e);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [key, handler, meta, shift, alt, enabled]);
}
